import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: theme.radii.md,
  overflow: "hidden",
  backgroundColor: theme.palette.white,
  flexShrink: 0,

  [theme.down("sm")]: {
    width: "100%",
    // FE-24: на узком экране табы прокручиваются, а не ломают строку
    overflowX: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
}));

export const SortTab = styled("button")(({ theme, $active }) => ({
  ...theme.typography.caption,
  fontWeight: $active ? 600 : 500,
  // FE-23: высота таба — тач-цель
  minHeight: theme.tapTarget,
  padding: `0 ${theme.spacing(4)}px`,
  border: "none",
  borderLeft: `1px solid ${theme.palette.border.main}`,
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "background-color .2s ease, color .2s ease",

  "&:first-of-type": {
    borderLeft: "none",
  },

  ...($active
    ? {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.white,
      }
    : {
        backgroundColor: "transparent",
        color: theme.palette.text.secondary,

        "&:hover": {
          backgroundColor: theme.palette.header.hoverBg,
        },
      }),
}));
